module.exports = __webpack_public_path__ + "static/media/triangles-left.3a5bc237.svg";